import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { environment } from "src/environments/environment";

export const landingGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (localStorage.getItem(environment.tokenPropertyName)) {
    router.navigate(["/services"]);
    return false;
  }

  return true;
};
